/** GrowthBook flags referenced by {@link TOOL_DEFINITIONS} entries. */
export const TOOL_FEATURE_FLAG_VIDEO_UNCENSORED = 'video_uncensored'

export const TOOL_FEATURE_FLAG_YOUTUBE_THUMBNAIL_GENERATOR = 'studio-youtube-thumbnail-generator'

/**
 * Also gates the "Use in workflow" launcher in Flow and the video generator, so one
 * switch covers every entry point into the Workflows POC.
 */
export const TOOL_FEATURE_FLAG_WORKFLOWS = 'studio-workflows'
